import type { HeroParams, HeroReturn, HomepageContentItem, FormattedTextParams } from '../types';
import { formatUSPCardTextContent } from '../helpers';

export default function (params: HeroParams): HeroReturn {
  const {
    _editable,
    _uid,
    backgroundColor,
    images,
    content,
    contentPositionMobile,
    contentPositionTablet,
    contentPositionDesktop,
    alignItems
  } = params;

  const processedContent = content.map((item): HomepageContentItem => {
    if (item.component === 's-formatted-text') {
      return formatUSPCardTextContent(item as FormattedTextParams);
    }
    return item;
  });

  return {
    module: 'SHomepageHero',
    _editable,
    _uid,
    backgroundColor,
    images: images[0],
    content: processedContent,
    alignItems,
    contentPositionMobile,
    contentPositionTablet,
    contentPositionDesktop
  };
}
